module.exports = __webpack_public_path__ + "static/media/7.f44abc21.svg";